// WaitingView is served from several URLs (the EHR extension deep-links to
// /telehealth-active), so they all have to light up the same "Telehealth" tab.
export const TELEHEALTH_WAITING_PATHS = ['/telehealth-waiting', '/telehealth-active', '/telehealth-live'];

export default [
  // Public waiting room (patient side) - no auth required
  {
    name: 'Telehealth Waiting Room',
    path: '/telehealth/:accountName',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/TelehealthWaitingRoomView.vue'),
    meta: { public: true }
  },
  // Waiting tab (default landing)
  {
    name: 'Telehealth Waiting',
    path: '/telehealth-waiting',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/WaitingView.vue')
  },
  // Live sessions tab (redirects to waiting — live sessions are now inline on the Waiting tab)
  {
    path: '/telehealth-live',
    redirect: '/telehealth-waiting'
  },
  // Completed sessions view
  {
    name: 'Telehealth Completed Sessions',
    path: '/telehealth-completed/:id?',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/CompletedSessionsView.vue')
  },
  // Full-page EHR import of a completed session's note (same pattern as /import-submission)
  {
    name: 'Import Session',
    path: '/import-session',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/ImportSessionView.vue')
  },
  // Active sessions URL - loads WaitingView (supports EHR embed with focus param)
  {
    name: 'Telehealth Active',
    path: '/telehealth-active',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/WaitingView.vue')
  },
  // AI Scribe - in-person recording
  {
    name: 'AI Scribe',
    path: '/scribe',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/ScribeView.vue')
  },
  // AI Template editor (dedicated full-page editor, like the forms editor)
  {
    name: 'Template Editor',
    path: '/telehealth-templates/:id/edit',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/AITemplateEditorView.vue')
  },
  // AI Templates management
  {
    name: 'Templates',
    path: '/telehealth-templates/:id?',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/AITemplatesView.vue')
  },
  // Redirect old dashboard URL to waiting tab
  {
    path: '/telehealth-dashboard',
    redirect: '/telehealth-waiting'
  },
  // Video call view for providers (embedded Jitsi)
  {
    name: 'Telehealth Call',
    path: '/telehealth-call/:sessionId',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/TelehealthCallView.vue')
  },
  // Video call view for patients (embedded Jitsi, uses accessToken)
  {
    name: 'Telehealth Patient Call',
    path: '/telehealth-join/:accessToken',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/TelehealthPatientCallView.vue'),
    meta: { public: true }
  },
  // Direct join view for shared invite links (bypasses waiting room)
  {
    name: 'Telehealth Direct Join',
    path: '/telehealth-direct/:inviteToken',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/TelehealthDirectJoinView.vue'),
    meta: { public: true }
  },
  // Post-call survey for patients (waiting room)
  {
    name: 'Telehealth Survey',
    path: '/telehealth-survey/:accessToken',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/TelehealthSurveyView.vue'),
    meta: { public: true }
  },
  // Post-call survey for direct join participants (shared invite)
  {
    name: 'Telehealth Invite Survey',
    path: '/telehealth-invite-survey/:inviteToken',
    component: () => import(/* webpackChunkName: "telehealth" */ '@/views/telehealth/TelehealthSurveyView.vue'),
    meta: { public: true }
  }
]
